module.exports = __webpack_public_path__ + "assets/img/8f4d52d4e82e790c4e26f3b38bf2865b.svg";